import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  headline() {
    return faker.random.words(3);
  },

  url() {
    return faker.internet.url();
  },

  linkOptions() {
    const options = ['_blank', '_self'];

    return faker.helpers.arrayElement(options);
  },

  altText() {
    return faker.lorem.sentence();
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },
});
